import { Icon } from '../components/Icon'
import { Badge } from '../components/ui'
import type { ComingSoonContent } from './comingSoonContent'

export function ComingSoonView({ title, icon, summary, bullets, dependency }: ComingSoonContent) {
  return (
    <div className="page">
      <section className="soon" aria-labelledby="soon-title">
        <span className="soon-icon"><Icon name={icon} size={26} /></span>
        <Badge tone="info">Coming soon</Badge>
        <h1 id="soon-title" className="soon-title">{title}</h1>
        <p className="soon-summary">{summary}</p>
        <ul className="soon-list">
          {bullets.map((b) => (
            <li key={b}><Icon name="check" size={14} /> {b}</li>
          ))}
        </ul>
        {dependency && <p className="soon-dep">{dependency}</p>}
      </section>
    </div>
  )
}
